import type { Stripe } from 'stripe';

const AFFIRM_FINANCE_AMOUNT_MINIMUM = 60000;
const AFFIRM_RUNTIME_MONTHS = 48;

export function canUseAffirm(
	price: Stripe.Price,
	promoCode: Stripe.PromotionCode | undefined
): boolean {
	if (!promoCode || !price.unit_amount || !promoCode.coupon?.amount_off) return true;

	const amounterAfterCoupon = price.unit_amount - (promoCode.coupon?.amount_off || 0);

	return amounterAfterCoupon > AFFIRM_FINANCE_AMOUNT_MINIMUM;
}

export function getAffirmRate(buyPrice: number): number {
	return buyPrice / AFFIRM_RUNTIME_MONTHS;
}
